import React, { useMemo } from 'react';
import { Heading } from '@zillow/constellation';
import styled from 'styled-components';
import { useCustomViewsContext } from '../context/CustomViewsContext';

const useGetHeadingText = () => {
  const { customViewsState } = useCustomViewsContext();
  return useMemo(() => {
    if (!customViewsState.isEdit) {
      return 'Custom views';
    }
    if (customViewsState.isCreate) {
      return 'Create a new view';
    }
    return 'Edit custom views';
  }, [customViewsState]);
};

export const DropdownHeader: React.FC = () => {
  const headingText = useGetHeadingText();
  return <GrayHeading level={'6'}>{headingText}</GrayHeading>;
};

const GrayHeading = styled(Heading)`
  background-color: #dddde1;
  padding: 12px 16px;
  border-top-right-radius: 8px;
  border-top-left-radius: 8px;
`;
